import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setLogin, setUser } from "../../store/user/actions";
import UserForm from "../../components/UserForm/UserForm";
import axiosPost from "../../helpers/axiosPost";
import constants from "../../constants";

export default function Login() {
  const values = {
    email: "",
    password: "",
  };

  const inputs = [
    {
      name: "email",
      type: "text",
      aria: "Email",
      placeholder: "Email Address",
      icon: "user",
      disabled: false,
    },
    {
      name: "password",
      type: "password",
      aria: "Password",
      placeholder: "Password",
      icon: "lock",
      disabled: false,
    },
  ];
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [captchaValue, setCaptchaValue] = useState(null);

  const handleSubmit = (data) => {
    setLoading(true);
    setError(false);

    if (!captchaValue) {
      setError({
        message: "Please complete the captcha!",
        statusCode: 401,
      });
      setLoading(false);
      return;
    }

    const params = {
      username: data.email,
      password: data.password,
      token: captchaValue
    };

    axiosPost({
      url: `${constants.AUTH_URL}/auth/login-token`,
      data: params,
      callback: (res) => {
        setLoading(false);
        sessionStorage.setItem("token", res.data.payload.token);
        sessionStorage.setItem("user", res.data.user.userCode);
        dispatch(setUser(res.data.user));
        dispatch(setLogin(true));
      },
      errorCallback: (err) => {
        setLoading(false);
        setError(true);
        setErrorMessage(err.message);
      },
    });
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };
  return (
    <section className="login-page">
      <UserForm
        title="Log in to your account"
        loading={loading}
        values={values}
        inputs={inputs}
        submit={handleSubmit}
        buttonText="Log in"
        type="login"
        error={error}
        errorMessage={errorMessage}
        handleCaptchaChange={handleCaptchaChange}
      />
    </section>
  );
}
